// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"6":"7db65160","8":"ba7bc274","179":"4201b500","238":"6aa289ef","536":"d2625e9d","650":"bdf67243","776":"2e07926c"}[chunkId] + ".js";
};